// @flow

import React from 'react';
import moment from 'moment';
import { Calendar } from 'react-date-range';

type Props = {
  date: string,
  handleDatePickerChange: Function,
}
const DatePicker = (props: Props) => (
  <Calendar
    date={moment(props.date)}
    onChange={props.handleDatePickerChange}
    firstDayOfWeek={1}
    theme={{
      Calendar: {
        position: 'absolute',
        zIndex: '10',
      },
    }}
  />
);

export default DatePicker;



// WEBPACK FOOTER //
// ./src/js/Components/DatePicker.js